
import UIFlash from './UIFlash.vue';
import { createComponent, computed, watch } from '@vue/composition-api';
import { TFlashItem } from '../types';

export default createComponent({
  name: 'UIFlashManager',
  props: {
    items: {
      required: true,
      type: Array as () => TFlashItem[],
    },
  },
  components: {
    UIFlash,
  },
  setup (props, { emit }) {
    const currentItem = computed(() => props.items[0]);
    watch(() => currentItem.value?.id, () => {
      if (!currentItem.value) return;
      setTimeout(() => {
        emit('next');
      }, currentItem.value.duration || 4000);
    });
    return {
      currentItem,
    };
  },
});
